<template>
    <v-app>
      <v-app-bar color="primary" app fixed>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color:white">{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color:#73FFEB; font-size:8px;">by Plataforma SIG</v-toolbar-title>
      </v-app-bar>
      <v-main>
        <router-view></router-view>
      </v-main>
      <v-bottom-navigation
          v-model="value"
          color="white"
          :background-color="color"
          app
          fixed
          grow
      >
        <v-btn @click="goKpi" v-if="canViewDemands">
          <span>KPIS</span>
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>

        <v-btn @click="goDemands" v-if="canViewDemands">
          <span>{{demmandsMenuTitle}}</span>
          <v-icon>mdi-phone</v-icon>
        </v-btn>

        <v-btn @click="goOrder" v-if="canViewOrder">
          <span>{{orderMenuTitle}}</span>
          <v-icon>mdi-cart</v-icon>
        </v-btn>

        <v-btn @click="goCalendar" v-if="canViewCalendar">
          <span>Agendas</span>
          <v-icon>mdi-calendar-clock</v-icon>
        </v-btn>

        <v-btn @click="goMenu">
          <span>Menu</span>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-app>
</template>
<script>

  export default {
    data: () => ({ 
      value: 0, 
      title: "",
      demmandsMenuTitle: "",
      orderMenuTitle: "",
      show: false,
      canViewDemands: false,
      canViewOrder: false,
      canViewCalendar: false,
    }),

    computed: {
      color () {
        switch (this.value) {
          case 0: return 'primary'
          case 1: return 'primary'
          case 2: return 'primary'
          case 3: return 'primary'
          case 4: return 'primary'
          default: return 'primary'
        }
      },
    },

    created(){
      let loginData = JSON.parse(localStorage.getItem("loginData"));
      
      if(loginData != null){
        let menu = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 24
        });

        let menuOrder = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 189
        });

        let canDemands = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 27
        });

        let canDemandsSignature = loginData.permissionsSignature.find(permission => {
          return permission == 4
        });

        let canOrder = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 216 || permission.menuId == 249
        });

        let canOrderSignature = loginData.permissionsSignature.find(permission => {
          return permission == 6 || permission == 11
        });

        let canCalendar = loginData.permissionsSignature.find(permission => {
          return permission == 6
        });

        if((canDemands != null || loginData.userData.userType == 2) && canDemandsSignature != null)
          this.canViewDemands = true;
        else
          this.canViewDemands = false;

        if(canOrder != null && canCalendar != null)
          this.canViewCalendar = true;
        else
          this.canViewCalendar = false;

        if(canOrder != null && canOrderSignature != null)
          this.canViewOrder = true;
        else
          this.canViewOrder = false;

        this.demmandsMenuTitle = menu != null && menu.name != null ? menu.name : "Processos";
        this.orderMenuTitle = menuOrder != null && menuOrder.name != null ? menuOrder.name : "Pedidos";

        if(this.demmandsMenuTitle.length > 12)
          this.demmandsMenuTitle = `${this.demmandsMenuTitle.substring(0, 9)}...`;

        if(this.orderMenuTitle.length > 12)
          this.orderMenuTitle = `${this.orderMenuTitle.substring(0, 9)}...`

        if(this.$route.name == "KPIS")
        {
          this.title = "KPIS";
          this.value = 0;
        }
        else if(this.$route.name == "ListDemmands")
        {
          let objLabel = loginData.labels.find(label => {
            return label.typeLabel == 1
          });
          this.title = `Lista de ${objLabel != null && objLabel.name != null ? objLabel.name: "Chamados"}`;
          this.value = 1;
        }
        else if(this.$route.name == "ListOrder")
        {
          let objLabel = loginData.labels.find(label => {
            return label.typeLabel == 17
          });
          this.title = `Lista de ${objLabel != null && objLabel.name != null ? objLabel.name : "Pedidos"}`;
          this.value = 2;
        }
        else if(this.$route.name == "Calendar")
        {
          this.title = "Agendas";
          this.value = 3;
        }
        else if(this.$route.name == "Menu")
        {
          this.title = "Menu";
          this.value = 4;
        }
      }
      else{
        this.$router.push('/');
      }
    },

    methods: {
      goKpi(){
        this.title = "KPIS";
        this.$router.push('kpis');
      },
      goDemands(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));

        let objLabel = loginData.labels.find(label => {
          return label.typeLabel == 1
        });

        this.title = `Lista de ${objLabel != null && objLabel.name != null ? objLabel.name : "Chamados"}`;
        this.$router.push('listDemmands');
      },
      goOrder(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));

        let objLabel = loginData.labels.find(label => {
          return label.typeLabel == 17
        });

        this.title = `Lista de ${objLabel != null && objLabel.name != null ? objLabel.name : "Pedidos"}`;
        this.$router.push('listOrder');
      },
      goMenu(){
        this.title = "Menu";
        this.$router.push('menu');
      },
      goCalendar(){
        this.title = "Agendas";
        this.$router.push('calendar');
      }
    }
  }
</script>

<style scoped>
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0;
}
</style>

<style>
.theme--light.v-btn.v-btn--has-bg {
  background-color: transparent/* !important*/;
}
.v-item-group.v-bottom-navigation .v-btn {
  height: inherit !important;
}
 /* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}
</style>